import { IconChevronDownSmall } from 'central-icons/IconChevronDownSmall';
import type { ReactNode } from 'react';

import {
  Menu,
  MenuButton,
  MenuList,
  MenuRadioGroup,
  MenuRadioItem,
} from '@revelio/ui';

import styles from './BranchLabelMenu.module.css';

/**
 * A tree panel's heading that opens a menu, for switching what the tree is
 * built from (a geography taxonomy, an industry list) where its levels are
 * named. The label stays the panel's heading; each item says where that
 * choice leads. Rendered inline so a pick stays inside the popover holding
 * the tree.
 */
export const BranchLabelMenu = ({
  label,
  value,
  children,
  inSelectMenu = false,
  onOpenChange,
}: {
  label: ReactNode;
  /** The `value` of the item currently in effect, which shows a tick. */
  value: string;
  children: ReactNode;
  /**
   * Hosted in a react-select menu, which hands focus straight back to its
   * input: the menu must neither trap focus nor close when focus leaves.
   */
  inSelectMenu?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => (
  <Menu modal={!inSelectMenu} onOpenChange={onOpenChange}>
    <MenuButton>
      <button type="button" className={styles.trigger}>
        {label}
        <IconChevronDownSmall size={12} />
      </button>
    </MenuButton>
    <MenuList
      side="bottom"
      align="start"
      portal={false}
      onFocusOutside={
        inSelectMenu ? (event) => event.preventDefault() : undefined
      }
    >
      <MenuRadioGroup value={value} indicator="none">
        {children}
      </MenuRadioGroup>
    </MenuList>
  </Menu>
);

export const BranchLabelMenuItem = ({
  value,
  onSelect,
  children,
}: {
  value: string;
  onSelect: () => void;
  children: ReactNode;
}) => (
  <MenuRadioItem value={value} onSelect={onSelect} className={styles.item}>
    {children}
  </MenuRadioItem>
);
